import React, { useEffect, useState } from "react";
import { IMG } from "../../../../../assets";
import { LINKS } from "../../../../../api/Links";

export default function Footer() {
  const [links, setLinks] = useState(null);

  const getLinksList = async () => {
    try {
      const res = await LINKS.GET_ALL();
      if (res.status !== 200) {
        throw new Error("Failed to fetch information");
      }
      setLinks(res.data[0]);
    } catch (error) {
      // console.log("Error loading topics: ", error);
    }
  };

  useEffect(() => {
    getLinksList();
  }, []);
  return (
    <div className="w-full flex flex-col md:flex-row justify-between items-center py-10">
      <a
        href="https://encoreevents.in/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img className="w-80" src={IMG.logo} alt="encore logo" />
      </a>
      {links !== null && (
        <div className="flex gap-5">
          <a
            href={`tel:+91${links.phone1}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="w-8 h-8 object-contain"
              src="https://www.freeiconspng.com/uploads/phone-call-icon-16.png"
              alt="icons"
            />
          </a>
          <a
            href={`https://wa.me/91${links.phone1}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="w-8 h-8 object-contain"
              src="https://www.cdnlogo.com/logos/w/29/whatsapp-icon.svg"
              alt="icons"
            />
          </a>
          <a href={links.instaLink} target="_blank" rel="noopener noreferrer">
            <img
              className="w-8 h-8 object-contain"
              src="https://upload.wikimedia.org/wikipedia/commons/a/a5/Instagram_icon.png"
              alt="icons"
            />
          </a>
        </div>
      )}
    </div>
  );
}
